<template>
  <div
    class="cells"
    :class="[ positions[position], { 'cells--indent': indent }, { 'cells--wrap': wrap } ]"
    :style="cellsStyle"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: 'AppCells',
  props: {
    position: {
      type: String,
      default: 'start',
    },
    indent: {
      type: Boolean,
      default: true,
    },
    wrap: {
      type: Boolean,
      default: true,
    },
    gap: {
      type: String,
      default: '10px 20px',
    },
    marginTop: { type: [String, Number], default: 0 },
    marginBottom: { type: [String, Number], default: 0 },
  },
  computed: {
    cellsStyle() {
      return {
        gap: this.gap,
        marginTop: this.indent ? '' : this.normalizeSize(this.marginTop),
        marginBottom: this.indent ? '' : this.normalizeSize(this.marginBottom),
      }
    }
  },
  data() {
    return {
      positions: {
        start: 'cells--start',
        end: 'cells--end',
        center: 'cells--center',
        between: 'cells--between'
      },
    }
  },
  methods: {
    normalizeSize(value) {
      return typeof value === 'number' ? `${value}px` : value
    },
  }
}
</script>

<style scoped lang="sass">
.cells
  display: flex
  align-items: center

  +max-w($desktop_sm)
    gap: 10px 5px

.cells--wrap
  flex-wrap: wrap

.cells--end
  justify-content: flex-end

.cells--start
  justify-content: flex-start

.cells--center
  justify-content: center

.cells--between
  justify-content: space-between

.cells--indent
  margin: 30px 0

  &:first-child
    margin-top: 0

.cells--start-vertical
  align-items: flex-start

.cells--end-vertical
  align-items: flex-end
</style>
